import { http, httpV2 } from "@/api";

/**
 * Solicita os modos de falhas disponíveis para uma unidade geradora.
 * @param {Number} resultSetId Id do conjunto de resultado a ser consultado.
 * @returns Array com modos de falhas para o resultado consultado.
 */
const GetFailureModes = function(resultSetId = 0)
{
	return httpV2.get(`/HydroGeneratingUnitDiagnostic/${resultSetId}/FailureModes`);
};

/**
 * Solicita os conjuntos de resultados dos modos de falhas.
 * @param {Object} requestParameters Parâmetros para a requisição dos conjuntos de resultados (evoluir para model).
 * @returns Array com resultados disponíveis para modos de falhas.
 */
const GetResultSets = function(requestParameters = {})
{
	return http.get(`/HydroGeneratingUnits/${requestParameters.monitoringElementId}/result-sets`,
		{
			params: {
				startDateTime: requestParameters.startDateTime,
				endDateTime:   requestParameters.endDateTime
		  },
		});
};

export default
{ GetFailureModes, GetResultSets };